import client from "../../../../client";
import type { RequestConfig, ResponseErrorConfig } from "../../../../client";
import type {
  PostApiCreateaccountMutationRequest,
  PostApiCreateaccountMutationResponse,
  PostApiCreateaccount401,
  PostApiCreateaccount403,
} from "../../../types/PostApiCreateaccountCreateaccount";

export function getPostApiCreateaccountCreateaccountUrl() {
  return `/api/CreateAccount/CreateAccount` as const;
}

/**
 * {@link /api/CreateAccount/CreateAccount}
 */
export async function postApiCreateaccountCreateaccount(
  data?: PostApiCreateaccountMutationRequest,
  config: Partial<RequestConfig<PostApiCreateaccountMutationRequest>> & {
    client?: typeof client;
  } = {}
) {
  const { client: request = client, ...requestConfig } = config;

  const res = await request<
    PostApiCreateaccountMutationResponse,
    ResponseErrorConfig<PostApiCreateaccount401 | PostApiCreateaccount403>,
    PostApiCreateaccountMutationRequest
  >({
    method: "POST",
    url: getPostApiCreateaccountCreateaccountUrl().toString(),
    data,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res;
}
